import React from 'react'
import { Button, Card } from "react-bootstrap";

import styles from './HelpCard.module.scss';

export default function HelpCard() {
    return (
      <Card className={styles.card}>
        <div className={styles.cardBg}>
          <h6>EYRN Scanning</h6>
          <h3 className="mb-3">What can I help you find today?</h3>
          <button type="button" className="btn-secondary mt-3">
            Ask a question
          </button>
          <div className={styles.spiral}></div>
        </div>
      </Card>
    );
}
